import React from 'react';
import PropTypes from 'prop-types';

export default class LeadTimeWarnings extends React.PureComponent {
  static propTypes = {
    machineMissing: PropTypes.bool.isRequired,
    couplerMissing: PropTypes.bool.isRequired,
    fullWidth: PropTypes.bool,
  };

  render() {
    const { machineMissing, couplerMissing, fullWidth } = this.props;

    return (
      <div
        className={`row ${fullWidth ? 'card-deck' : 'justify-content-center'}`}
      >
        <div className={`${fullWidth ? 'banner-container' : ''}`}>
          {machineMissing && couplerMissing && (
            <div
              className={`alert alert-warning ${fullWidth ? 'card-body' : ''}`}
            >
              <i className="fa fa-info-circle fa-lg text-danger"></i> Lead times
              and pricing cannot be confirmed until the{' '}
              <span className="lead-time-focus">machine make &amp; model</span>{' '}
              and <span className="lead-time-focus">lugging</span> are provided
            </div>
          )}
          {machineMissing && !couplerMissing && (
            <div className="alert alert-warning">
              <i className="fa fa-info-circle fa-lg text-danger"></i> Lead times
              and pricing cannot be confirmed until the{' '}
              <span className="lead-time-focus">machine make &amp; model</span>{' '}
              is provided
            </div>
          )}
          {!machineMissing && couplerMissing && (
            <div className="alert alert-warning">
              <i className="fa fa-info-circle fa-lg text-danger"></i> Lead times
              and pricing cannot be confirmed until the{' '}
              <span className="lead-time-focus">lugging</span> is provided
            </div>
          )}
        </div>
      </div>
    );
  }
}
